import clearLocalStorage from "#/utils/clearLocalStorage";
import { useCartStore } from "../../store/cart";
import type { PaymentConfig, PaymentHandler } from "../../types/payment";
import { createPaymentErrorHandler } from "../services/PaymentErrorHandler";
import { checkOrderStatus, clearSavedData, closeWebSocket, handleOrderError, handleRmsDiscounts } from "./basePaymentHandler";

export function createSBPHandler(): PaymentHandler {
	const storeCart = useCartStore();

	const ws: any | null = null;
	const errorHandler = createPaymentErrorHandler();

	/**
	 * Обработка статусов WebSocket для SBP
	 */
	const handleWebSocketStatus = (data: any, config: PaymentConfig): void => {
		const status = data.params?.status;
		if (data.params?.number) {
			storeCart.orderNumber = data.params?.number;
		}
		if (data.params?.external_id) {
			storeCart.orderExternalId = data.params?.external_id;
		}

		if (status === "sent") {
			handleRmsDiscounts(data, config);
			storeCart.isButtonDisabled = false;
		} else if (status === "sent_fiscalization") {
			checkOrderStatus(config, 1);
		} else if (status === "waiting_payment") {
			checkOrderStatus(config, 4);
		} else if (data.params?.show_success_order_screen) {
			checkOrderStatus(config, 3);
			const wsToUse = config.ws || ws;
			closeWebSocket(wsToUse);
			storeCart.tabName = null;
			storeCart.isAdultConfirmed = false;
			clearLocalStorage(["cart"]);
			clearSavedData();
		} else if (config.orderErrors?.includes(status)) {
			storeCart.isButtonDisabled = false;
			handleOrderError(data, config, ws, errorHandler);
		}
	};

	return {
		handleWebSocketStatus(data: any, config: PaymentConfig): void {
			handleWebSocketStatus(data, config);
		},
	};
}
